export const SET_TOAST_DURATION_IN_MILLISECONDS = (durationInSeconds: number) =>
  durationInSeconds * 1000;
